<!--
 * @Descripttion: 服务费订单列表
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="service-order-list">
    <xrk-table
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    ></xrk-table>
  </div>
</template>

<script lang="tsx" setup>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseButton
} from 'xrk-components';
import { getServiceCol } from '../fields/columns';
import { getServiceSearch } from '../fields/searchs';

import {
  serviceFeeList,
  orderExport,
  batchDownload
} from '../data-source/apis';

const route = useRoute();
const router = useRouter();

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置',
    beforeReset: () => {
      // 清除路由上的查询参数
      if (route.query.orderNo) {
        router.replace({
          query: { force: Date.now() }
        });
      }
    }
  },
  searchColumns: [...getServiceSearch(route.query.orderNo)],
  otherComponents: [
    {
      render() {
        return (
          <>
            {
              <BaseButton
                type="primary2"
                click={async () => {
                  await batchDownload({
                    downloadType: 901,
                    queryParam: JSON.stringify(searchedParams.value)
                  });
                }}
              >
                批量下载回单
              </BaseButton>
            }
            <BaseButton
              type="primary2"
              click={async () => {
                await orderExport({
                  exportType: 8001,
                  reqParam: searchedParams.value
                });
              }}
            >
              导出
            </BaseButton>
          </>
        );
      }
    }
  ].filter(Boolean)
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号'
    }),
    ...getServiceCol()
  ].filter(Boolean),
  baseConfig: {}
});
const searchedParams = ref({});

const getListAjax = async params => {
  const [orderStartTime, orderEndTime] = params.orderTime || ['', ''];
  const [orderPayStartTime, orderPayEndTime] = params.orderPayTime || ['', ''];

  const reqData = {
    ...params,
    orderStartTime,
    orderEndTime,
    orderPayStartTime,
    orderPayEndTime
  };
  const data = await serviceFeeList(reqData);
  searchedParams.value = reqData;
  return data;
};
</script>
<style lang="scss"></style>
